import React from 'react'
import TeacherDash from '../../Components/TeacherComponents/TeacherDash/TeacherDash'
import FeedbackForm from '../../Components/Feedback/FeedbackForm'

function FeedPageT() {
  return (
   <TeacherDash>
    <FeedbackForm/>
   </TeacherDash>
  )
}

export default FeedPageT